import { combineReducers } from 'redux';

import geoFence from './geoFence';

export default combineReducers({
  geoFence,
});
